import React from "react";
import "./Content.css";

export default function Content(props) {
  return <section className="content">{props.children}</section>;
}
